import React, { Component } from 'react';
import { Button, Card, Dropdown, Header, Label, Table } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';

class AverageTableWithReportButton extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };
    }
    render() {
        let {
            tableHeader, questionList, tableRibbonLabel, buttonReport, buttonReportText, graphically
        } = this.props;
        return (
            <div>
                <Table celled selectable compact striped color="blue" >
                    <Table.Header fullWidth>
                        <Table.Row >
                            <Table.HeaderCell >
                               Broj studenata koji su pristupili anketi

                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Ukupan prosjek na anketi

                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center" >
                                Rezultati
                            </Table.HeaderCell>
                        </Table.Row>


                    </Table.Header>
                    <Table.Body>

                        <Table.Row >
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>
                                {buttonReport && <Header style={IconHeader} textAlign="center" >


                                    <Button

                                        icon="download"
                                        content={buttonReportText}
                                        // labelPosition="right"
                                        color="blue"
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={this.printReport}
                                    >

                                    </Button>


                                </Header>}
                            </Table.Cell>
                        </Table.Row>


                    </Table.Body>

                </Table>
            </div>
        );
    }
}

export default AverageTableWithReportButton;



// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/AverageTableWithReportButton.js